import * as actionTypes from '../actions/actionTypes'

const initialState = {
  records: [],
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 0,
    lastPage: 0,
    from: 0,
    to: 0
  },
  appraisalTypes: [],
  filtered: false,
  filterLoading: [],
  filterCompanies: [],
  filterForms: [],
  // filterOrgs: [],
  filterLevelGroups: [],
  filterData: [],
  gradeData: [],
  filterLoadingQueue: [],
  loading: false,
  data: [],
  total: null,
  adjustData: [],
  dataTable: [],
  dataList: [],
  success: false,
  tableLoading: false,
  horizontalForceRankLoading: false
}

// FETCH_APPRAISAL_TYPE_OPTION

// START
const fetchAppraisalTypeOptionsStart = (state, action) => {
  return {
    ...state
  }
}

// SUCCESS
const fetchAppraisalTypeOptionsSuccess = (state, action) => {
  return {
    ...state,
    appraisalTypes: action.data.map(item => {
      return {
        appraisal_type_id: item.value_list_id,
        appraisal_type_code: item.value_list_code,
        appraisal_type_name: item.value_list_name
      }
    })
  }
}

// FAILED
const fetchAppraisalTypeOptionsFailed = (state, action) => {
  return {
    ...state
  }
}

// FETCH_COMPANY_OPTION

// START
const fetchCompanyOptionsStart = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: [...state.filterLoadingQueue, 'company_id']
  }
}

// SUCCESS
const fetchCompanyOptionsSuccess = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'company_id'),
    filterCompanies: action.data
  }
}

// FAILED
const fetchCompanyOptionsFailed = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'company_id')
  }
}

// FETCH_FORM_OPTION

// START
const fetchFormOptionsStart = (state, action) => {
  return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'form_id'] }
}

// SUCCESS
const fetchFormOptionsSuccess = (state, action) => {
  return {
    ...state,
    filterForms: action.data,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'form_id')
  }
}

// FAILED
const fetchFormOptionsFailed = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'form_id')
  }
}

// FETCH_ORGANIZATION_OPTION

// START
const fetchForcedOrganizationOptionsStart = (state, action) => {
  return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'org_id'] }
}

// SUCCESS
const fetchForcedOrganizationOptionsSuccess = (state, action) => {
  return {
    ...state,
    filterOrgs: action.data,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'org_id')
  }
}

// FAILED
const fetchForcedOrganizationOptionsFailed = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'org_id')
  }
}

// FETCH_LEVEL_OPTION

// START
const fetchForcedLevelGroupOptionsStart = (state, action) => {
  return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'level_group_id'] }
}

// SUCCESS
const fetchForcedLevelGroupOptionsSuccess = (state, action) => {
  return {
    ...state,
    filterLevelGroups: action.data,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'level_group_id')
  }
}

// FAILED
const fetchForcedLevelGroupOptionsFailed = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'level_group_id')
  }
}

const fetchHorizontalForceRankFilterStart = (state, action) => {
  return {
    ...state,
    filtered: true,
    tableLoading: true
  }
}

const fetchHorizontalForceRankFilterSuccess = (state, action) => {
  return {
    ...state,
    dataTable: action.data,
    dataList: action.data?.force_rank || [],
    tableLoading: false
  }
}

const fetchHorizontalForceRankFilterFailed = (state, action) => {
  return {
    ...state,
    filtered: false,
    tableLoading: false
  }
}

const fetchHorizontalForceRankGradeStart = (state, action) => {
  return {
    ...state,
    filtered: true
  }
}

const fetchHorizontalForceRankGradeSuccess = (state, action) => {
  return {
    ...state,
    gradeData: action.data
  }
}

const fetchHorizontalForceRankGradeFailed = (state, action) => {
  return {
    ...state,
    filtered: false,
    message: action.errorMessage
  }
}

const fetchHorizontalForceRankListStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const fetchHorizontalForceRankListSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    data: action.data
  }
}

const fetchHorizontalForceRankListFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchHorizontalForceRankTableStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const fetchHorizontalForceRankTableSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    dataList: action.data
  }
}

const fetchHorizontalForceRankTableFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchHorizontalForceRankCalculateStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const fetchHorizontalForceRankCalculateSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    data: action.data
  }
}

const fetchHorizontalForceRankCalculateFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const createHorizontalForceRankStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const createHorizontalForceRankSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createHorizontalForceRankFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchAdjustStart = (state, action) => {
  return {
    ...state,
    filterLoading: true
  }
}

const fetchAdjustSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterData: action.data,
    pagination: action.pagination,
    total: action.total,
    adjustData: action.adjustData
  }
}

const fetchAdjustFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchHorizontalForceRankStart = (state, action) => {
  return {
    ...state,
    // message: action.errorMessage
    horizontalForceRankLoading: true
  }
}
const fetchHorizontalForceRankSucess = (state, action) => {
  return {
    ...state,
    dataTable: action.data,
    horizontalForceRankLoading: false
  }
}
const fetchHorizontalForceRankFailed = (state, action) => {
  return {
    ...state,
    message: action.errorMessage,
    horizontalForceRankLoading: false
  }
}

const clearHorizontal = (state, action) => {
  return {
    ...state,
    // gradeData: [],
    // filterLoading: [],
    // filterData: [],
    pagination: {
      total: 0,
      perPage: 10,
      currentPage: 0,
      lastPage: 0,
      from: 0,
      to: 0
    },
    // total: null,
    // adjustData: [],
    dataTable: []
  }
}

// REDUCER
const reducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH_APPRAISAL_TYPE_OPTION
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_START:
      return fetchAppraisalTypeOptionsStart(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS:
      return fetchAppraisalTypeOptionsSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FAILED:
      return fetchAppraisalTypeOptionsFailed(state, action)

    // FETCH_COMPANY_OPTIONS
    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_START:
      return fetchCompanyOptionsStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchCompanyOptionsSuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchCompanyOptionsFailed(state, action)

    // FETCH_FORM_OPTIONS
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_START:
      return fetchFormOptionsStart(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchFormOptionsSuccess(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchFormOptionsFailed(state, action)

    // FETCH_ORGANIZATION_OPTIONS
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START:
      return fetchForcedOrganizationOptionsStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchForcedOrganizationOptionsSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchForcedOrganizationOptionsFailed(state, action)

    // FETCH_ORGANIZATION_OPTIONS
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_START:
      return fetchForcedLevelGroupOptionsStart(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchForcedLevelGroupOptionsSuccess(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchForcedLevelGroupOptionsFailed(state, action)

    // FETCH_HORIZONTAL_FORCERANK_FILTER
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_FILTER_START:
      return fetchHorizontalForceRankFilterStart(state, action)
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_FILTER_SUCCESS:
      return fetchHorizontalForceRankFilterSuccess(state, action)
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_FILTER_FAILED:
      return fetchHorizontalForceRankFilterFailed(state, action)

    // FETCH_HORIZONTAL_FORCERANK_GRADE
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_GRADE_START:
      return fetchHorizontalForceRankGradeStart(state, action)
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_GRADE_SUCCESS:
      return fetchHorizontalForceRankGradeSuccess(state, action)
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_GRADE_FAILED:
      return fetchHorizontalForceRankGradeFailed(state, action)

    // FETCH_HORIZONTAL_FORCERANK_LIST
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_LIST_START:
      return fetchHorizontalForceRankListStart(state, action)
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_LIST_SUCCESS:
      return fetchHorizontalForceRankListSuccess(state, action)
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_LIST_FAILED:
      return fetchHorizontalForceRankListFailed(state, action)

    case actionTypes.FETCH_HORIZONTAL_FORCERANK_TABLE_START:
      return fetchHorizontalForceRankTableStart(state, action)
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_TABLE_SUCCESS:
      return fetchHorizontalForceRankTableSuccess(state, action)
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_TABLE_FAILED:
      return fetchHorizontalForceRankTableFailed(state, action)

    // FETCH_HORIZONTAL_FORCERANK_LIST
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_CALCULATE_START:
      return fetchHorizontalForceRankCalculateStart(state, action)
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_CALCULATE_SUCCESS:
      return fetchHorizontalForceRankCalculateSuccess(state, action)
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_CALCULATE_FAILED:
      return fetchHorizontalForceRankCalculateFailed(state, action)

    case actionTypes.CREATE_HORIZONTAL_FORCERANK_START:
      return createHorizontalForceRankStart(state, action)
    case actionTypes.CREATE_HORIZONTAL_FORCERANK_SUCCESS:
      return createHorizontalForceRankSuccess(state, action)
    case actionTypes.CREATE_HORIZONTAL_FORCERANK_FAILED:
      return createHorizontalForceRankFailed(state, action)

    // FETCH_ADJUST
    case actionTypes.FETCH_ADJUST_START:
      return fetchAdjustStart(state, action)
    case actionTypes.FETCH_ADJUST_SUCCESS:
      return fetchAdjustSuccess(state, action)
    case actionTypes.FETCH_ADJUST_FAILED:
      return fetchAdjustFailed(state, action)
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_START:
      return fetchHorizontalForceRankStart(state, action)
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_SUCCESS:
      return fetchHorizontalForceRankSucess(state, action)
    case actionTypes.FETCH_HORIZONTAL_FORCERANK_FAILED:
      return fetchHorizontalForceRankFailed(state, action)
    case actionTypes.CLEAR_HORIZONTAL_RECORD:
      return clearHorizontal(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    // DEFAULT
    default:
      return state
  }
}

export default reducer
